import axios from 'axios'
import 'url-search-params-polyfill';

const tpaas = {
    doLogin: function(username, password, locale) {
        const params = new URLSearchParams();
        params.append('username', username);
        params.append('password', password);
        params.append('locale', locale);
        return axios.post('https://canal.hipercom.es/outlook/login',params)
        .then(function (response) {
            if (response.data) {
               return response.data;
            }
        })
        .catch(function (error) {
            throw error.response.data.error;
        });
    },

    createMeet: function (username, password, locale, meetParams) {
        const params = new URLSearchParams();
        params.append('username', username);
        params.append('password', password);
        params.append('locale', locale);
        params.append('meet', JSON.stringify(meetParams)); // esto se complicará por que es un objeto anidado
        return axios.post('https://canal.hipercom.es/outlook/createmeeting', params)
        .then(function (response) {
            if (response.data)
                return response.data;
        })
        .catch(function (error) {
            throw error.response.data.error;
        });
    },
};

export default tpaas;


// WEBPACK FOOTER //
// ./src/helpers/tpaas.js